import React, { useEffect, useState } from "react";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";
import { Box, Card, Typography } from "@mui/material";
import { formatDecimal } from "../../util/NumberHelper";

export default function Formula(props) {
  const {
    label,
    id,
    readOnly,
    required,
    onChange,
    //onSaveDraft = () => {},
    formulaType,
    value,
    formValues,
    formScores,
  } = props;
  const {
    handleSubComponentLoaded = (
      subComponent = { ...ComponentRef },
      isLoaded = false
    ) => {},
  } = props;
  const { itemIndex, level, messageTime } = props;

  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    if (!readOnly) {
      //console.log('formScores', JSON.stringify(formScores));
      let formulasCount = 0;

      const sectionScores = formScores.find((score) => score.id === id);
      if (!sectionScores) {
        setInternalValue(0);
        onChange(id, 0);
        return;
      }

      const formulaIdsUsedInCalculation = sectionScores.scores
        .filter((t) => t.useFormulaScoringForCalculation)
        .map((t) => t.id);
      formulasCount = formulaIdsUsedInCalculation.length;
      let combinedScores = sectionScores.scores;
      if (formulasCount > 0) {
        combinedScores = [
          ...sectionScores.scores,
          ...formScores
            .filter((score) => formulaIdsUsedInCalculation.includes(score.id))
            .flatMap((score) => score.scores),
        ];
      }

      const scoresWithoutFormulaCount = combinedScores.length - formulasCount;
      let formulaValue = combinedScores.reduce((acc, formValue) => {
        if (!formValue.score) {
          return 0;
        }
        if (formulaType !== "substract") {
          return acc + parseFloat(formValue.score.actualScore);
        } else {
          return acc - parseFloat(formValue.score.actualScore);
        }
      }, 0);

      if (formulaValue > 0 && formulaType === "average") {
        //formulaValue = formulaValue / (sectionScores?.scores.length ?? 1);
        formulaValue =
          formulaValue /
          (scoresWithoutFormulaCount > 0 ? scoresWithoutFormulaCount : 1);
      } else if (formulaValue > 0 && formulaType === "percentage") {
        const maxScore = combinedScores.reduce((acc, formValue) => {
          if (!formValue.score) {
            return 0;
          }

          return acc + parseFloat(formValue.score.maxScore);
        }, 0);
        formulaValue = (formulaValue / maxScore) * 100;
      }

      setInternalValue(formulaValue);
      onChange(id, formulaValue);
    }
  }, [formScores]);

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("Formula", itemIndex, level, messageTime),
      true
    );
  }, []);

  if (internalValue === undefined) {
    return false;
  }

  if (readOnly) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="subtitle1"
          fontWeight={"bold"}
        >{`${label}: `}</Typography>
        <Typography>{formatDecimal(internalValue)}</Typography>
      </Box>
    );
  }

  return (
    <Card sx={{ padding: 1, paddingLeft: 2 }}>
      <Typography variant="subtitle1">{`${label}: `}</Typography>
      <Typography>{formatDecimal(internalValue)}</Typography>
    </Card>
  );
}
